import { BeneficiaryCategory } from '/@/modules/beneficiary/enums/BeneficiaryCategory';
import { BeneficiaryAdultMeta } from '/@/modules/estateaccount/models/meta/BeneficiaryAdultMeta';
import { BeneficiaryChildMeta } from '/@/modules/estateaccount/models/meta/BeneficiaryChildMeta';
import { BeneficiaryOrganizationMeta } from '/@/modules/estateaccount/models/meta/BeneficiaryOrganizationMeta';

export class BeneficiaryAccountMeta {
  /**
   * @param meta
   * @returns {BaseBeneficiaryMeta}
   */
  static factory(meta) {
    switch (meta?.category) {
      case BeneficiaryCategory.ADULT.key:
        return new BeneficiaryAdultMeta(meta);
      case BeneficiaryCategory.CHILD.key:
        return new BeneficiaryChildMeta(meta);
      case BeneficiaryCategory.ORGANIZATION.key:
        return new BeneficiaryOrganizationMeta(meta);
      default:
        return null;
    }
  }
}
